import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BrokerService } from 'src/app/broker/service/broker.service';
import { Policy } from 'src/app/cp-member/models/policy.model';
import { CPMemberService } from 'src/app/cp-member/services/CPMember.service';
import { HRService } from 'src/app/member/services/hr.service';
import { Roles } from 'src/app/shared/enums/roles.enum';
import { AuthService } from 'src/app/shared/services/auth.service';
import { RoleService } from 'src/app/shared/services/role.service';
import { SMService } from 'src/app/sm/service/sm.service';
import { TrackingService } from 'src/app/Tracking.service';
import { CorporatePolicyModel } from '../../models/corporate-policy.model';
import { CPPolicyService } from '../../services/cp-policy.service';

@Component({
  selector: 'app-cp-header',
  templateUrl: './cp-header.component.html',
  styleUrls: ['./cp-header.component.scss'],
})
export class CpHeaderComponent implements OnInit {
  name: string;
  isHrView = false;
  userRole: string;
  user;
  currentPolicy: Policy;
  policies = [];

  isHr: boolean;
  isMember: boolean;

  corporate: CorporatePolicyModel = new CorporatePolicyModel();
  corporates: CorporatePolicyModel[] = [];
  isOpen: boolean = false;
  unseenNotificationCount = 0;
  notifications = [];
  
  constructor(
    private authService: AuthService,
    private roleService: RoleService,
    private cpMemberService: CPMemberService,
    private brokerService: BrokerService,
    private smService: SMService,
    private policyService: CPPolicyService,
    private hrService: HRService,
    private router: Router,
    private tracking: TrackingService
  ) {}

  ngOnInit() {
    this.userRole = this.authService.role;
    this.policyService.policies.subscribe(policies => {
      this.policies = policies;
    });

    if (this.authService.role === Roles.CPMember || this.authService.role === Roles.CPHR) {
      this.cpMemberService.getMemberOrHrCorporate().then(cor => {
        this.corporate = cor;
        this.tracking.corpName = cor.code;
      });
      this.cpMemberService.hrDetails.subscribe(m => {
        this.name = m.name;
        this.user = m;
      });
      if (this.name === undefined) {
        this.cpMemberService.selfMemberDetails.subscribe(m => {
          this.name = m.insuredName;
          this.user = m;
          this.tracking.employee_id = m.memberIdEmpId;
        });
      }
    } else if (this.authService.role === Roles.Broker) {
      this.policyService.getBrokerCorporatesAndPolicies().then(c => {
        this.corporates = c;
        this.corporate = c[0];
        this.policies = [];
        this.policies = this.corporate.policies;
      });
      this.brokerService.brokerProfile.subscribe(x => {
        this.name = x.name;
        this.user = x;
      });
    } else if (this.authService.role === Roles.SM) {
      this.smService.smProfile.subscribe(x => {
        this.name = x.name;
        this.user = x;
      });
      this.policyService.getSMCorporatesAndPolicies().then(c => {
        this.corporates = c;
        this.corporate = c[0];
        this.policies = [];
        this.policies = this.corporate.policies;
      });
    }
    this.policyService.currentPolicy.subscribe(async (policy: any) => {
      this.currentPolicy = policy;
      if (this.isHrView) {
        await this.cpMemberService.GetUnSeenHrNotificationCount().then(x => {
          this.unseenNotificationCount = x.count;
        });
      } else {
        await this.cpMemberService.GetUnSeenMemberNotificationCount().then(x => {
          this.unseenNotificationCount = x.count;
        });
      }
    });
    // this.authService.userName.subscribe(name => (this.userName = name));
  }

  changeCorporate(event) {
    this.policyService.currentCorporate.next(event);
    this.corporate = event;
    this.policies = [];
    this.policies = event.policies;
    this.policyService.policies.next([]);
    this.policyService.allPolicies.next([]);
    this.policyService.policies.next(event.policies);
    this.policyService.allPolicies.next(event.policies);
    this.policyService.currentPolicy.next(event.policies[0]);
  }

  redirectToManageProfile(){
    this.tracking.pushEvent("profile_page_interaction", {});
    this.router.navigate(['/cp-member/manage-profile']);

  }
}
